import {officeGroup} from "@signals";
import {batch} from "@preact/signals-react";
import React from 'react'
import {BACKEND_APIS} from "../../../../@constants";
import {AutocompleteAsyncSeeker} from "@ui-seeker/core";
import { chainFinish } from '@components/NewCommonFilters/@services/chainFinish'

export default function AppCommonFiltersOfficeGroupAutocomplete({ onOptions, onFinishAjax, ...props }) {
    return <AutocompleteAsyncSeeker
        label={"Pickup office Group"}
        placeholder={"All office Group"}
        urlAjax={`${BACKEND_APIS.CRUD}/user/offices_group?selectorFormat=true`}
        value={officeGroup.value || null}
        onChange={e => batch(() => {
            officeGroup.value = e.target.value
        })}
        filters={{
            officeGroupID: officeGroup.value,
        }}
        onFinishAjax={chainFinish(onFinishAjax, onOptions)}
        {...props}
    />
}